import { supabase } from './supabaseClient';

export const PLATFORM_SETTINGS_ROW_ID = 1;

export const DEFAULT_ORGANIZATION_CONTACT = {
  email: 'support@echojham.com',
  phone: '+63 (0) 2 1234 5678',
};

const trimText = (value) => String(value ?? '').trim();

export const normalizeOrganizationContact = (row = {}) => {
  const source = row || {};
  return {
    email: trimText(source.email ?? source.organization_email ?? source.organizationEmail),
    phone: trimText(source.phone ?? source.organization_phone ?? source.organizationPhone),
  };
};

export const resolveOrganizationContact = (row) => {
  const normalized = normalizeOrganizationContact(row || {});
  return {
    email: normalized.email || DEFAULT_ORGANIZATION_CONTACT.email,
    phone: normalized.phone || DEFAULT_ORGANIZATION_CONTACT.phone,
  };
};

export const buildSupportMailUrl = ({ email, requestCode } = {}) => {
  const to = trimText(email);
  if (!to) return null;

  const code = trimText(requestCode);
  const subject = code ? `Booking request (${code})` : 'Booking request';

  const params = new URLSearchParams({
    view: 'cm',
    fs: '1',
    to,
    su: subject,
  });

  return `https://mail.google.com/mail/?${params.toString()}`;
};

export const openSupportMail = ({ email, requestCode } = {}) => {
  const url = buildSupportMailUrl({ email, requestCode });
  if (!url) return false;
  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
};

export const copyTextToClipboard = async (value) => {
  const text = trimText(value);
  if (!text) return false;

  if (navigator?.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return true;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  const copied = document.execCommand('copy');
  document.body.removeChild(textarea);
  return copied;
};

export const loadOrganizationContact = async () => {
  try {
    const { data, error } = await supabase
      .from('platform_settings')
      .select('organization_email, organization_phone')
      .eq('id', PLATFORM_SETTINGS_ROW_ID)
      .maybeSingle();

    if (error) throw error;
    if (!data) return { ...DEFAULT_ORGANIZATION_CONTACT };
    return normalizeOrganizationContact(data);
  } catch (error) {
    console.warn('Could not load organization contact settings:', error);
    return { ...DEFAULT_ORGANIZATION_CONTACT };
  }
};
